module.exports = __webpack_public_path__ + "2949f68ee566a65868d70ef9e4d22304.MP3";